import { getImagenURL } from '@/Utiles/Formatos';
import { State } from './index'
export function Panel({ config }: { config: State }) {
    const { backgroundColor, img, fluid } = config;
    return <div style={{ padding: fluid ? '0 0 0 0' : '60px 0', background: backgroundColor }}>
        {fluid ? <img id='ImagenEditable' src={getImagenURL(img)} width='100%' alt='panel a' /> : <div className="container">
            <img id='ImagenEditable' src={getImagenURL(img)} width='100%' alt='panel a' />
        </div>}
    </div>
}